import styled from 'styled-components';
import * as grid from 'view/styles/grid';
import { cardStyle } from '../portal-card';
import { cardGutterStyle } from '../project-card';
import { token } from '@atlaskit/tokens';
import { colors } from '@atlaskit/theme';

export { PortalName, Description, IconContainer, Content, Container } from '../portal-card/styled';

/**
 * This height has to be same as Card title font size (h500).
 */
export const titleSkeletonHeight = '21px';

export const Root = styled.li`
    ${cardStyle}
    ${cardGutterStyle}
    border: solid 1px ${token('color.border', colors.N40)};
    background-color: ${token('elevation.surface.raised', colors.N0)};
`;

export const NameWrapper = styled.div`
    margin-bottom: ${token('space.100', '8px')};
`;

export const Actions = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    position: absolute;
    color: ${token('color.skeleton', colors.N20)};
    top: ${token('space.100', '8px')};
    right: ${token('space.100', '8px')};
`;

export const ActionsLeft = styled(Actions)`
    position: initial;
    width: ${grid.multiple(5).px};
    margin-top: -${grid.multiple(6).px};
`;
